<template>
    <div class="groupDetail pages">
        <div class="content1">
            <div class="d1">
                <p class="t">
                    <span><img src="../../assets/images/newIcon/vipgroup_configuration_icon.png" alt="">基础数据</span>
                    <span>
                        <img src="../../assets/images/newIcon/details_customerbianji_icon.png" alt="">
                        <img src="../../assets/images/newIcon/delete_icon.png" alt="">
                    </span>
                </p>
                <el-form class="forms" ref="form" label-position="right" label-width="90px">
                    <el-form-item label="渠道名称：">
                        <span>群组名称</span>
                    </el-form-item>
                    <el-form-item label="渠道描述：">
                        <span>群组描述文字</span>
                    </el-form-item>
                    <el-form-item label="业务系统：">
                        <span>颐安中台</span>
                    </el-form-item>
                    <el-form-item label="创建人：">
                        <span>吴彦祖</span>
                    </el-form-item>
                    <el-form-item label="创建时间：">
                        <span>2021.10.10 18:00:00</span>
                    </el-form-item>
                    <el-form-item label="渠道类型：">
                        <span v-if="type==2">小程序</span>
                        <span v-if="type==3">网页</span>
                        <span v-if="type==1">APP</span>
                    </el-form-item>
                    <el-form-item label="渠道方式：">
                        <span v-if="type==2">链接跳转到小程序</span>
                        <span v-if="type==3">点击跳转到网页</span>
                        <span v-if="type==1">点击跳转到APP</span>
                    </el-form-item>
                    <el-form-item label="页面名称：">
                        <span>国庆活动特惠</span>
                    </el-form-item>
                </el-form>
            </div>
            <div class="d2">
                <p class="t">
                    <span><img src="../../assets/images/newIcon/vip_viplabel_icon.png" alt="">会员标签</span>
                </p>
                <p class="tags">
                    <el-tag size="medium">中等标签</el-tag>
                    <el-tag size="medium">中等标签</el-tag>
                    <el-tag size="medium">中等标签</el-tag>
                    <el-tag size="medium">中等标签</el-tag>
                    <el-tag size="medium">中等标签</el-tag>
                    <el-tag size="medium">中等标签</el-tag>
                    <el-tag size="medium">中等标签</el-tag>
                </p>
            </div>
            <div class="d3">
                <p class="t">
                    <span>
                        <img src="../../assets/images/newIcon/qudao_link_icon.png" alt="">渠道链接
                    </span>
                    <span>
                        
                    </span>
                </p>
                <el-form class="forms" ref="form" label-position="right" label-width="120px">
                    <el-form-item label="渠道类型：">
                        <span v-if="type==2">小程序</span>
                        <span v-if="type==3">网页</span>
                        <span v-if="type==1">APP</span>
                    </el-form-item>
                    <el-form-item label="应用模版：">
                        <span>
                            模版名称
                            <el-button type="text">预览</el-button>
                        </span>
                    </el-form-item>
                    <el-form-item v-if="type==2" label="小程序二维码：">
                        <p class="ewm">
                            <img src="../../assets/images/newIcon/wx_dpt_bc@2x.png" alt="">
                            <span>
                                <span>保存</span>
                            </span>
                          
                        </p>
                      
                    </el-form-item>
                    <el-form-item v-if="type==3 || type==1" label="渠道二维码：">
                        <p class="ewm">
                            <img src="../../assets/images/newIcon/wx_dpt_bc@2x.png" alt="">
                            <span>
                                <span>保存</span>
                            </span>
                          
                        </p>
                      
                    </el-form-item>
                    <el-form-item label="渠道链接：">
                        <p class="links">
                            <span>https://developer.o…</span>
                            <span>复制链接</span>
                        </p>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="content2">
            <div class="d1 mb-30">
                <div class="title">
                    <div class="t1">
                        <p>
                            <img class="log" src="../../assets/images/newIcon/qudao_data_icon.png" alt="">
                            渠道数据
                            <span style="padding-left:15px;">2021.10.10  10:00:00更新</span>
                        </p>
                    </div>
                  
                </div>
                <div class="f2 mb-30">
                    <div class="bf" :class="types==1 ? 'active' : ''" @click="chagef2(1)">
                        <img v-show="types!=1" src="../../assets/images/newIcon/channel_people_icon.png" alt="">
                        <img v-show="types==1" src="../../assets/images/newIcon/qudao_jifen_icon.png" alt="">
                        <p>
                            <span>渠道总人数</span>
                            <span>36,254</span>
                        </p>
                    </div>
                    <div class="bf" :class="types==2 ? 'active' : ''"  @click="chagef2(2)">
                        <img v-show="types!=2" src="../../assets/images/newIcon/vip_addcustomer_icon.png" alt="">
                        <img v-show="types==2" src="../../assets/images/newIcon/channel_risingwhite_icon.png" alt="">
                        <p>
                            <span>昨日新增</span>
                            <span>36,254</span>
                        </p>
                    </div>
                    <div class="bf" :class="types==3 ? 'active' : ''"  @click="chagef2(3)">
                        <img v-show="types!=3" src="../../assets/images/newIcon/qudao_time_icon.png" alt="">
                        <img v-show="types==3" src="../../assets/images/newIcon/channel_durationwhite_icon.png" alt="">
                        <p>
                            <span>平均浏览时长</span>
                            <span>36,254</span>
                        </p>
                    </div>
                    <div class="bf" :class="types==4 ? 'active' : ''"  @click="chagef2(4)">
                        <img v-show="types!=4" src="../../assets/images/newIcon/vipgroup_accessblue_icon.png" alt="">
                        <img v-show="types==4" src="../../assets/images/newIcon/channel_accesswhite_icon.png" alt="">
                        <p>
                            <span>访问次数</span>
                            <span>36,254</span>
                        </p>
                    </div>
                    <div class="bf" :class="types==5 ? 'active' : ''"  @click="chagef2(5)">
                        <img v-show="types!=5" src="../../assets/images/newIcon/qudao_kedanjia_icon.png" alt="">
                        <img v-show="types==5" src="../../assets/images/newIcon/channel_pricewhite_icon.png" alt="">
                        <p>
                            <span>客单价</span>
                            <span>36,254</span>
                        </p>
                    </div>
                    <div class="bf" :class="types==6 ? 'active' : ''"  @click="chagef2(6)">
                        <img v-show="types!=6" src="../../assets/images/newIcon/qudao_jiazhi_icon.png" alt="">
                        <img v-show="types==6" src="../../assets/images/newIcon/channel_valuewhite_icon.png" alt="">
                        <p>
                            <span>渠道价值</span>
                            <span>36,254</span>
                        </p>
                    </div>
                </div>
                <div  id="survey"></div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            activeName:"1",
            options:[{name:'昨日'}],
            value:"",
            types:"1",
            type:"1"
        }
    },
    created(){
        this.type=this.$route.query.type
        console.log(this.type)
    },
    mounted() {
        this.init2();
    },
    methods: {
        init2(){
            let d1=[
                {data:"01.01",name:'渠道总人数',val:1000},
                {data:"01.02",name:'渠道总人数',val:600},
                {data:"01.03",name:'渠道总人数',val:700},
                {data:"01.04",name:'渠道总人数',val:300},
                {data:"01.05",name:'渠道总人数',val:200},
                {data:"01.06",name:'渠道总人数',val:300},
            ]
            let data=[...d1];
            const chart = new this.$chart({
            container: 'survey',
            autoFit: true,
            height: 500,
            padding: [20,60,80,60],
            });
            // chart
            // .interval({
            //     theme: {
            //     defaultColor: 'red',
            //     },
            // })
            // .position(0);
            chart.data(data);
            chart.scale({
            month: {
                range: [0, 1],
            },
            temperature: {
                nice: true,
            },
            });

            chart.tooltip({
            showCrosshairs: true,
            shared: true,
            showMarkers: true,
            });
            chart.axis('val', {
            label: {
                formatter: (val) => {
                return val;
                },
            },
            });

            chart
            .line()
            .position('data*val')
            .color('name',["#5B8FF9","#B959F6",'#FF9D4D'])
            .shape('smooth')

            chart.render();
        },
        chagef2(type){
            this.types=type;
        },
        handleClick(){
            
        },
    },
}
</script>
<style lang="less" scoped>
    .groupDetail{
        display: flex;
        justify-content: space-between;
        .content1{
            padding:30px;
            width:392px;
            box-sizing: border-box;
            background: #fff;
            .t{
                margin-bottom:15px;
                span{
                    &:first-child{
                        img{
                            margin-right:10px;
                        }
                    }
                }
                display: flex;
                justify-content: space-between;
                img{
                    width:20px;
                    height:20px;
                    vertical-align: middle;
                    margin-right:15px;
                    &:last-child{
                        margin:0;
                    }
                }
            }
            .d1{
                border-bottom:1px solid #E8E8E8;
                
                .forms{
                    img{
                        margin-right:10px;
                        width:32px;
                        height:32px;
                        vertical-align: middle;
                    }
                }
                /deep/ .el-form-item__content{
                    padding-left:30px;
                }
            }
            .d2{
                padding-top:30px;
                padding-bottom:15px;
                border-bottom:1px solid #E8E8E8;
                /deep/ .el-tabs__nav-wrap::after{
                    display: none;
                }
                .tags{
                    padding-top:15px;
                    /deep/ .el-tag{
                        border-radius: 30px;
                        margin-bottom:10px;
                    }
                }
            }
            .d3{
                margin-top:30px;    
                 .ewm{
                     display: flex;
                     align-items: flex-end;
                    img{
                        display:block;
                        width:120px;
                        height:120px;
                    }
                    span{
                        span{
                             display: inline-block;
                            margin-left: 15px;
                            padding:0px 15px;
                            border-radius: 16px;
                            border: 1px solid #258EF7;
                            font-size: 14px;
                            font-weight: 400;
                            color: #258EF7;
                        }
                       
                    }
                }
                .links{
                    width:200px;
                    display: flex;
                    justify-content: center;
                    // padding:0 10px;
                    border-radius: 16px;
                    border: 1px solid #D8D8D8;
                    span{
                        padding:0 6px;
                        display: inline-block;
                        font-size: 14px;
                        font-weight: 400;
                        color: #258EF7;
                        &:first-child{
                            width:100px;
                            overflow: hidden;
                            text-overflow:ellipsis;
                            white-space: nowrap;
                            border-right: 1px solid #d8d8d8;
                        }
                    }
                }
            }
        }
        .content2{
            background: #fff;
            width:calc(100% - 420px); 
            .f2{
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                // justify-content: space-between;
                div{
                    // display: inl;
                    margin-bottom:15px;
                    width:32%;
                    height: 92px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    padding:30px 0px;
                    box-sizing: border-box;
                    border-radius: 8px;
                    background: #F0F0F0;
                    img{
                        width:54px;
                        height:54px;
                    }
                    p{
                        margin-left:15px;
                        span{
                            display: block;
                            &:first-child{
                                font-size: 14px;
                                font-weight: 400;
                                color: #2E2E2E;
                            }
                            &:last-child{
                                margin-top:10px;
                                font-size: 24px;
                                font-weight: bold;
                                color: #2E2E2E;
                            }
                        }
                    }
                }
                .active{
                    background: #327EFF;
                    span{
                        color:#fff !important;
                    }
                }
            }
            .d1{
                box-sizing: border-box;
                padding:30px;
                background: #fff; 
            }
           
        }
        .title{
            margin-bottom:30px;
            .t1{
                display: flex;
                justify-content: space-between;
                p{
                    .log{
                        width:20px;
                    }
                    img{
                        width:16px;
                        vertical-align: middle;
                        margin-right:10px;
                    }
                    /deep/ .el-input .el-input__inner{
                        background: #F6F6F9;
                        border:0px;
                    }
                    span{
                        font-size: 12px;
                        font-weight: 400;
                        color: #999999;
                        
                    }
                }
            }
            .t2{
                padding-left:30px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-top:12px;
                font-size: 12px;
                font-weight: 400;
                color: #333333;
                p{
                    color: #999999;
                    img{
                        margin-right:15px;
                        width:18px;
                        height:18px;
                        vertical-align: middle;
                    }
                }
            }
        }
        .c0091FF{
            color:#0091FF !important;
        }
    }
    
</style>